<template>
  <div class="main">
    <div class="search">
      <a-input
        class="search-i"
        style="margin-right :24px"
        v-model:value="name"
        placeholder="请输入备案名称"
      ></a-input>
      <div class="search-box">
        <span class="span">按阵地类型查找:&nbsp;&nbsp;</span>
        <el-cascader
          ref="cascaderRef"
          popper-class="cascader-popper-class"
          v-model="positionCate"
          :options="options"
          :props="{value: 'id', label: 'name'}"
          placeholder="全部"
        >
          <template #default="{ node, data }">
            <el-tooltip
              v-if="data.name.length > 14"
              class="box-item"
              effect="dark"
              :content="data.name"
              placement="top-start"
            >
              <span class="title">{{ data.name }}</span>
            </el-tooltip>
            <span v-else class="title">{{ data.name }}</span>
          </template>
        </el-cascader>
        <el-button class="sbutton" @click="refreshData()">查询</el-button>
      </div>
    </div>
    <div style="border: 1px solid #EBEBEB; width: 862px">
      <el-table :data="records" style="width: 862px">
        <el-table-column prop="name" label="备案名称" min-width="20%" :show-overflow-tooltip="true" />
        <el-table-column
          prop="mainBody"
          label="所属平台"
          min-width="20%"
          :show-overflow-tooltip="true"
        />
        <el-table-column prop="recorderName" label="备案人" min-width="20%" />
        <el-table-column prop="positionType" label="阵地" min-width="20%">
          <template #default="scope">
            <el-tooltip
              class="table-column-cate"
              effect="dark"
              :content="scope.row.positionType"
              placement="top-start"
            >
              <span class="title">{{ scope.row.positionType }}</span>
            </el-tooltip>
          </template>
        </el-table-column>
        <el-table-column prop="recordTime" label="备案时间" min-width="22%" />
        <el-table-column fixed="right" label="操作" width="80px">
          <template v-slot:default="scope">
            <div v-if="!scope.row.status" class="sp-btn" @click="spdetail(scope.row)">
              <span class="span-op">审批</span>
            </div>
            <!-- <div v-html="scope.row.status" @click="spdetail(scope.row)"></div> -->
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div>
      <div class="page-wrapper">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-sizes="[20, 50, 100]"
          :page-size="size"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
        ></el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import { useRouter } from "vue-router";
import { message } from "ant-design-vue";
import myAxios from "@/api/request";
import { zdManagerListAjax } from "@/api/zdManager";

export default {
  props: {
    list: {
      type: Object
    }
  },
  setup() {
    const router = useRouter();
    const spdetail = _item => {
      router.push("/zdspDetail/" + _item.id);
    };
    return {
      spdetail
    };
  },
  data() {
    return {
      name: null,
      current: 1,
      size: 20,
      total: 0,
      records: [],
      currentPage: 1,
      positionCate: "",
      options: []
    };
  },
  watch: {
    list(newVal) {
      this.allData = newVal;
      this.total = newVal?.total || 0;
      this.currentPage = newVal?.current;
      this.size = newVal?.size;
      // newVal?.records?.forEach(item => {
      //   if (item.status == 0) {
      //     item.status =
      //       "<span style='color:#FB9C00;cursor:pointer'>审批</span>";
      //   }
      // });
      this.records = newVal?.records;
    }
  },
  mounted() {
    this._zdManagerListAjax();
  },
  methods: {
    _zdManagerListAjax() {
      zdManagerListAjax().then(res => {
        if (res.data2.code === 200) {
          this.options = [
            {
              name: "全部",
              id: 0
            },
            ...res.data
          ];
        }
      });
    },
    refreshData() {
      const reg = new RegExp(" / ", "g");
      const text = this.$refs.cascaderRef
        .getCheckedNodes()[0]
        ?.text?.replace(reg, "-");
      const positionCate = text === "全部" ? "" : text;
      this.$emit("refreshData", {
        current: this.current,
        size: this.size,
        status: this.status,
        name: this.name,
        positionCate
      });
    },
    handleSizeChange(size) {
      this.size = size;
      this.refreshData();
    },
    handleCurrentChange(current) {
      this.current = current;
      this.refreshData();
    },
    deleteItem(item) {
      myAxios({
        url: "/positionRecord",
        params: { id: item },
        method: "DELETE"
      }).then(res => {
        message.info("删除成功");
        this.refreshData();
      });
    }
  }
};
</script>

<style lang="scss" scoped>
@import "@/assets/css/cascader.scss";

@media screen and (min-width: 960px) {
  .main {
    width: 862px;
  }
}

@media screen and (min-width: 1200px) {
  .main {
    width: 862px;
  }
}

.main {
  margin: 0 auto;
}
::v-deep .el-button.is-link:focus,
.el-button.is-link:hover {
  color: var(--el-color-primary);
}
.search {
  height: 32px;
  margin-bottom: 20px;
  width: calc(100% - 65px);
  display: flex;
  justify-content: space-between;
  .search-box {
    display: flex;
    align-items: center;
  }
  /deep/.ant-input {
    width: 240px;
    border-radius: 3px;
  }
  /deep/.el-cascader {
    width: 240px;
  }
}

.search-i {
  width: 240px;
  height: 32px;
}

.sbutton {
  width: 60px;
  height: 32px;
  background: #286cfb;
  border-radius: 4px;
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #ffffff;
  margin-left: 16px;
}

.span {
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 600;
  color: #666;
  line-height: 22px;
}

.page-wrapper {
  height: 80px;
  background: #fff;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  margin-right: 80px;
}
.tableOp {
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #286cfb;
  line-height: 22px;
}
/deep/.el-table .cell .title {
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  overflow: hidden;
  text-overflow: ellipsis;
}
/deep/.el-table {
  .sp-btn {
    .span-op {
      color: rgba(0, 0, 0, 0.9);
      &:hover {
        color: #fb9c00;
        cursor: pointer;
      }
    }
  }
}
/deep/.cascader-popper-class {
  .el-cascader-node.in-active-path {
    .el-icon {
      color: #286cfb;
    }
  }
  .el-cascader-node:not(.is-disabled):hover {
    background: rgba(40, 108, 251, 0.1);
  }
  .el-cascader-node.is-active {
    .el-icon {
      color: #286cfb;
    }
  }
}
</style>